import { createAction } from '@reduxjs/toolkit'
import BigNumber from 'bignumber.js'

export const updateData = createAction<{
  rewardsBalance: string,
  claimPercent: number
}>('rewards/updateData')
export const updateLoading = createAction<{ isLoading: boolean }>('rewards/updateLoading')
export const resetRewardsState = createAction<void>('rewards/resetRewardsState')
